<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GuestLayout'
})
</script>

<template>
  <v-app class="app-image">
    <v-main class="d-flex align-center">
      <slot />
    </v-main>
  </v-app>
</template>

<style scoped>
.app-image {
  background-image: url('@/assets/images/login_background.webp');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
